import dayjs from "dayjs";

export const DATETIME = 'YYYY-MM-DD HH:mm';
export const TIME = 'HH:mm';
export const DATE = 'YYYY-MM-DD';

export const SERVER_DATETIME = 'DD-MM-YYYY HH:mm'
export const SERVER_DATE = 'DD-MM-YYYY' //this is default store format in the DB?
export const SERVER_TIME = 'HH:mm'

export function format(dt, format) {
    return dt.format(format)
}

export function formatDate(dt) {
    return format(dt, DATE)
}

export function formatTime(dt) {
    return format(dt, TIME)
}

export function formatDateTime(dt) {
    return format(dt, DATETIME)
}

export function parse(dt, format) {
    return dayjs.utc(dt, format)
}

export function parseDateTime(dt) {
    return parse(dt, DATETIME)
}

export function parseDate(dt) {
    return parse(dt, DATE)
}

export function parseTime(dt) {
    return parse(dt, TIME)
}
